import * as React from 'react';
import * as colors from '../../colors';
import styled from '../../utils/styled';
import { distance } from '../../distance';
import { Icon } from '../Icon';
import { getFontStyle } from '../../textStyles';
const StyledCloseButton = styled.a `
  ${getFontStyle({ size: 'medium' })}

  position: absolute;
  top: ${distance.medium};
  right: ${distance.medium};
  background-color: ${colors.transparent};
  padding: 0;
  border: none;
  align-self: start;
  cursor: pointer;
  color: ${colors.black};
  opacity: 0.2;
  transition: opacity 0.2s ease-out;

  &:hover {
    opacity: 0.5;
  }
`;
/**
 * A simple close button as used in Modal dialogs.
 */
export const CloseButton = Object.assign((props => (<StyledCloseButton {...props}>
    <Icon name="Close" size={1.1}/>
  </StyledCloseButton>)) as React.SFC<React.HTMLAttributes<HTMLAnchorElement>>, { inner: {
        get StyledCloseButton() { return StyledCloseButton as typeof StyledCloseButton; },
        get Icon() { return Icon as typeof Icon; }
    } });
CloseButton.displayName = 'CloseButton';
